import { state } from 'cerebral/tags'
import { compute } from 'cerebral'

export default namespace => {
  return compute(
    state`selectr.${namespace}.options`,
    state`selectr.${namespace}.input.value`,
    (options, value, get) => {
      if (!options) {
        return []
      }
      return options.reduce((acc, option, index) => {
        if (option.label.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
          const { label } = option
          acc.push({
            label,
            index
          })
        }
        return acc
      }, [])
    }
  )
}
